import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Bygningsendring from './Bygningsendring.jsx'
import BygningsendringIcon from '../../../images/Bygningsendring.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class BygningsendringList extends Component {
    state = {
        bygningsendringer: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getBygningsendringer = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/bygningsendring`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                bygningsendringer: [...this.state.bygningsendringer, ...data.bygningsendringer],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }


    toggleBygningsendringer = () => {
        if (this.props.antall == 0) return

        if (this.state.bygningsendringer.length == 0) {
            this.getBygningsendringer()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallBygningsendringer = this.state.continuationToken ? `${this.state.bygningsendringer.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleBygningsendringer}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={BygningsendringIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('bygningsendringer')} ({antallBygningsendringer})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.bygningsendringer.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.bygningsendringer.map((b, index) => { return (<Bygningsendring key={b.byggId} bygningsendring={b} antall={this.props.antall} isLast={index==this.state.bygningsendringer.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getBygningsendringer}>
                                <span>{t('hent.bygningsendringer')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BygningsendringList)